import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client'
import styled from 'styled-components'
import { Progress } from 'antd'
import { CONFORMITY_STATS_QUERY } from '../../../../graphql/Conformity'
import CentredLoader from '../../../../components/CentredLoader'

interface IProps {
  selectedUser: number | undefined
}

const Metrics = (props: IProps): JSX.Element => {
  const { t } = useTranslation()

  const { selectedUser } = props
  const { data, loading } = useQuery(CONFORMITY_STATS_QUERY, {
    variables: { userId: selectedUser },
  })

  if (loading) return <CentredLoader />

  const {
    doneInMonthCount,
    assignedInMonthCount,
    todoTodayCount,
    doneTodayCount,
  } = data.conformityUserStats

  return (
    <>
      <ProgressInfo>
        <span>{t('monthly')}</span>
        <Progress
          type="circle"
          percent={(doneInMonthCount / assignedInMonthCount) * 100}
          format={() => `${doneInMonthCount} / ${assignedInMonthCount}`}
        />
      </ProgressInfo>
      <ProgressInfo>
        <span>{t('daily')}</span>
        <Progress
          type="circle"
          percent={
            todoTodayCount === 0 ? 100 : (doneTodayCount / todoTodayCount) * 100
          }
          format={() => `${doneTodayCount} / ${todoTodayCount}`}
        />
      </ProgressInfo>
    </>
  )
}

const ProgressInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .ant-progress {
    margin: 0 15px;
  }
`

export default Metrics
